import { render, staticRenderFns } from "./Overlayer.vue?vue&type=template&id=3ce0a55a&scoped=true"
import script from "./Overlayer.vue?vue&type=script&lang=js"
export * from "./Overlayer.vue?vue&type=script&lang=js"
import style0 from "./Overlayer.vue?vue&type=style&index=0&id=3ce0a55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0a55a",
  null
  
)

export default component.exports